module.exports = __webpack_public_path__ + "img/clinic_mens_on_click.fc7d75b2.jpg";